import React, { useRef, useEffect } from "react";
import { Spinner } from "components/common";
import { MenuButton } from "./MenuButton";

export function SchedulerToolsMenu({
  isOpen,
  onToggle,
  onClose,
  onRunScheduler,
  onRunRecipientScheduler,
  isRunningScheduler,
  isRunningRecipient,
}: {
  isOpen:                  boolean;
  onToggle:                () => void;
  onClose:                 () => void;
  onRunScheduler:          () => void;
  onRunRecipientScheduler: () => void;
  isRunningScheduler:      boolean;
  isRunningRecipient:      boolean;
}) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!isOpen) return;
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) onClose();
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [isOpen, onClose]);

  const isBusy = isRunningScheduler || isRunningRecipient;

  return (
    <div ref={ref} className="relative">
      <button
        onClick={onToggle}
        disabled={isBusy}
        className={`p-2 rounded-lg transition-colors relative ${
          isOpen
            ? "bg-gray-800 text-white"
            : "bg-white border border-gray-200 text-gray-500 hover:bg-gray-50"
        } disabled:opacity-50`}
        title="Scheduler tools"
      >
        {isBusy ? (
          <Spinner className="h-4 w-4" />
        ) : (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="3" />
            <path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" />
          </svg>
        )}
      </button>

      {isOpen && (
        <div className="absolute right-0 top-10 z-50 w-52 bg-white rounded-lg shadow-lg border border-gray-200 py-2">
          <p className="px-3 pb-1.5 text-xs font-medium text-gray-400 uppercase tracking-wide">Scheduler</p>
          <MenuButton onClick={onRunScheduler} disabled={isBusy}>
            {isRunningScheduler ? "Running…" : "Run scheduler"}
          </MenuButton>
          <MenuButton onClick={onRunRecipientScheduler} disabled={isBusy}>
            {isRunningRecipient ? "Running…" : "Run recipient scheduler"}
          </MenuButton>
        </div>
      )}
    </div>
  );
}
